var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { TREE_VIEW_CHECK_BEHAVIOR } from './types';
function uncheckNodeFromIDs(node, checkedIds) {
    var findedIdx = checkedIds.findIndex(function (id) { return id === node.id; });
    if (findedIdx > -1) {
        checkedIds.splice(findedIdx, 1);
    }
}
function findCheckedAncestor(node, checked) {
    return node.getAncestors().find(function (parent) { return checked.find(function (checkedId) { return checkedId === parent.id; }); });
}
export function isNodeChecked(node, checked, checkBehavior) {
    if (checkBehavior === void 0) { checkBehavior = TREE_VIEW_CHECK_BEHAVIOR.simple; }
    if (!node) {
        return false;
    }
    if (checkBehavior !== TREE_VIEW_CHECK_BEHAVIOR.simple &&
        checkBehavior !== TREE_VIEW_CHECK_BEHAVIOR.fullHierarchical) {
        return !!findCheckedAncestor(node, checked);
    }
    return checked.some(function (checkedId) { return checkedId === node.id; });
}
function uncheckAncestors(checkedNode, newCheckedIds) {
    var checkedAncestor = findCheckedAncestor(checkedNode, newCheckedIds);
    if (checkedAncestor) {
        checkedNode.getAncestors().every(function (ancs) {
            uncheckNodeFromIDs(ancs, newCheckedIds);
            if (ancs === checkedAncestor) {
                return false;
            }
            ancs.getSiblings().forEach(function (child) {
                newCheckedIds.push(child.id);
            });
            return true;
        });
    }
}
function checkDescendants(checkedNode, newCheckedIds) {
    checkedNode.getDescendants().forEach(function (descnd) { return uncheckNodeFromIDs(descnd, newCheckedIds); });
    newCheckedIds.push(checkedNode.id);
}
function checkAncestors(checkedNode, newCheckedIds, behavior) {
    checkedNode.getAncestors().every(function (ancs) {
        var _a, _b, _c, _d;
        if ((_b = (_a = ancs.parent) === null || _a === void 0 ? void 0 : _a.children) === null || _b === void 0 ? void 0 : _b.every(function (child) { return isNodeChecked(child, newCheckedIds, behavior); })) {
            (_d = (_c = ancs.parent) === null || _c === void 0 ? void 0 : _c.children) === null || _d === void 0 ? void 0 : _d.forEach(function (child) { return uncheckNodeFromIDs(child, newCheckedIds); });
            newCheckedIds.push(ancs.parent.id);
            return true;
        }
        return false;
    });
}
export function computeCheckedIds(behavior, checkedNode, checkedIds) {
    if (behavior === void 0) { behavior = TREE_VIEW_CHECK_BEHAVIOR.simple; }
    var newCheckedIds = __spreadArrays(checkedIds);
    switch (behavior) {
        case TREE_VIEW_CHECK_BEHAVIOR.hierarchical:
            if (isNodeChecked(checkedNode, newCheckedIds, behavior)) {
                uncheckAncestors(checkedNode, newCheckedIds);
                return newCheckedIds;
            }
            checkDescendants(checkedNode, newCheckedIds);
            checkAncestors(checkedNode, newCheckedIds, behavior);
            return newCheckedIds;
        case TREE_VIEW_CHECK_BEHAVIOR.descendantsHierarchical:
            if (isNodeChecked(checkedNode, newCheckedIds, behavior)) {
                uncheckAncestors(checkedNode, newCheckedIds);
                return newCheckedIds;
            }
            checkDescendants(checkedNode, newCheckedIds);
            return newCheckedIds;
        case TREE_VIEW_CHECK_BEHAVIOR.fullHierarchical:
            if (isNodeChecked(checkedNode, newCheckedIds, behavior)) {
                var descIds_1 = checkedNode.getDescendants().map(function (node) { return node.id; });
                return newCheckedIds.filter(function (checkedId) { return !descIds_1.includes(checkedId); });
            }
            checkedNode.getAncestors().forEach(function (node) {
                if (node === checkedNode || !isNodeChecked(node, newCheckedIds, behavior)) {
                    newCheckedIds.push(node.id);
                }
            });
            return newCheckedIds;
        default:
            if (checkedIds.find(function (id) { return id === checkedNode.id; })) {
                return checkedIds.filter(function (id) { return id !== checkedNode.id; });
            }
            return __spreadArrays(checkedIds, [checkedNode.id]);
    }
}
//# sourceMappingURL=selectionHelpers.js.map